import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';
import { ApiError } from '../models/api.model';

const STATUS_MESSAGES: Record<number, string> = {
  0: 'Unable to reach the server. Please check your connection.',
  400: 'The request could not be processed. Please check your input.',
  401: 'Your session has expired. Please log in again.',
  403: 'You do not have permission to perform this action.',
  404: 'The requested resource was not found.',
  409: 'This request conflicts with existing data.',
  422: 'Some fields need your attention.',
  500: 'Something went wrong on our end. Please try again shortly.',
};

function friendlyMessage(status: number, fallback?: string): string {
  return STATUS_MESSAGES[status] ?? fallback ?? 'Unable to complete your request. Please try again.';
}

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const notify = inject(NotificationService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      const message = friendlyMessage(err.status, err.error?.message);

      if (err.status === 401) {
        auth.clearSession();
        notify.error(message);
        router.navigate(['/student/login']);
      } else if (err.status === 0 || err.status >= 500) {
        notify.error(message);
      }

      const apiError: ApiError = {
        status: err.status,
        message,
        errors: err.error?.errors,
      };
      return throwError(() => apiError);
    }),
  );
};
